/**
 * Thin page wrapper — the actual UI lives under `templates/policy-hub`. Kept
 * separate so the router (`src/router/index.js`) can import a stable page
 * entry without pulling in the template's ~700 lines of layout code at parse
 * time (matches the pattern used by other app-wide pages like adhoc-cases).
 */
import PolicyHub from "../templates/policy-hub";

export default PolicyHub;
